export default "# Auto-generated from python/pyproject.toml by scripts/sync_torch_version.mjs.\n# Do not edit manually.\n__version__ = \"0.0.84\"\n"